<template>
	<div class="visa">
		<back-to></back-to>
		<section class="visa-swiper">
			<img class="image-ad"
				:src="'https://sweetour-pic.obs.cn-north-1.myhuaweicloud.com/VISA2025.PNG?v='+Math.random()" alt="">
			<img class="image-ad"
				:src="'https://sweetour-pic.obs.cn-north-1.myhuaweicloud.com/20250527.1.png?v='+Math.random()" alt="">

			<div class="visa-process">
				<h2>签证流程</h2>
				<span><img :src="'https://m.sweetour.com/qian/images/p.png?v='+Math.random()" alt=""></span>
			</div>
		</section>

		<!-- 列表 -->
		<van-list class="visaList" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
			:immediate-check="false">
			<div class="visaList-item" v-for="(item,index) in data_product_array" :key="index"
				@click="$router.push({ path: '/visadetail',query:{id:item.id}})">
				<span class="visaList-item_left">
					<img :src="item.picturePath" alt="">
					<label for="">
						<p>{{item.cfd}}送签</p>
					</label>
				</span>
				<span class="visaList-item_right">
					<h2>{{item.title}}</h2>
					<p>{{item.strengths}}</p>
					<label for="">
						￥{{item.refPrice}}
						<font>起</font>
					</label>
				</span>
			</div>
		</van-list>
	</div>
</template>

<script>
	import BackTo from '@/components/BackTo.vue'
	export default {
		name: 'visa',
		components: {
			BackTo
		},
		data() {
			return {
				loading: false,
				finished: false,
				page: 1,
				data_product_array: []
			}
		},
		mounted() {
			this.getList()
		},
		methods: {
			onLoad() {
				setTimeout(() => {
					this.loading = false;
					this.page = this.page + 1
					this.getList()
				}, 500);
			},
			getList() {
				var data = {
					"pageIndex": this.page,
					"pageSize": 10,
					"object": {
						"platformid": "" + this.$platformid,
						"is_sny": 2,
						"isself": 0,
						"proProperty": 2
					}
				}
				this.$_post(
					this.$connectHttpDayun + '/team/mobile/indirect/pagefxwdcj', data
				).then(res => {
					console.log(res)
					res.objects.forEach(ele => {
						console.log(JSON.parse(ele.pd_json))
						ele.pd_json = JSON.parse(ele.pd_json)
						ele.cfd = ''
						if (ele.pd_json != "") {
							ele.pd_json.pod.forEach((le, i) => {
								if (i + 1 == ele.pd_json.pod.length) {
									ele.cfd = ele.cfd + le.Pod
								} else {
									ele.cfd = ele.cfd + le.Pod + '、'
								}
							})
						}
						ele.strengths = ele.strengths.map(item => (item.strength)).join("、")
					})
					if (this.page == 1) {
						this.data_product_array = res.objects
					} else {
						this.data_product_array = this.data_product_array.concat(res.objects)
					}
					if (res.objects.length < 10) {
						this.finished = true;
					}

				})
			},
		}
	}
</script>

<style scoped>
	.visa-swiper {
		width: 100%;

	}

	.visa-serch {
		display: flex;
		align-items: center;
		height: 78px;
		border-radius: 10px;
		background-color: #fff;
		box-shadow: 0 0 10px #d1d1d1;
		font-family: PingFangSC-Semibold, sans-serif;
		font-size: 26px;
		color: #b2b2b2;
		width: 710px;
		margin: 0 auto;
		margin-top: 14px;
		padding: 0 30px;
		box-sizing: border-box;
	}

	.visa-serch img {
		width: 40px;
	}

	.visa-serch p {
		text-align: center;
		width: 100%;
		padding-right: 40px;
	}

	.visa-img img {
		width: 100%;
		margin-top: 14px;
	}

	.visa-success {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 160px;
		margin-top: 14px;
	}

	.visa-success span {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.visa-success span:first-child {
		position: relative;
	}

	.visa-success span:first-child::after {
		content: "";
		height: 24px;
		border-right: 1px solid #e5e5e5;
		width: 1px;
		position: absolute;
		top: 50%;
		right: 0;
		transform: translateY(-50%);
	}

	.visa-success img {
		height: 34px;
		width: 33px;
		padding-right: 7px;
	}

	.visa-success .title {
		margin-top: 18px;
		margin-bottom: 18px;
	}

	.visa-success label {
		display: flex;
		align-items: center;
	}

	.visa-success p {
		font-size: 30px;
		font-weight: bold;
	}

	.visa-process {
		width: 100%;
		margin-top: 9px;
		margin-bottom: 9px;
		padding: 0 20px;
		box-sizing: border-box;
	}

	.visa-process h2 {
		font-size: 30px;
		height: 86px;
	}

	.visa-process span {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.visa-process img {
		width: 95%;
	}

	.visa-hot {
		width: 100%;
	}

	.visa-hot_title {
		width: 100%;
		padding: 0 20px;
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 86px;
		margin-top: 30px;
	}

	.visa-hot_title h2 {
		font-size: 30px;
	}

	.visa-hot_title label {
		display: flex;
		align-items: center;
		font-size: 26px;
		color: #adadad;
	}

	.visa-hot_title img {
		width: 14px;
		height: 28px;
		padding-left: 7px;
	}

	.visa-hot_nav {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		font-size: 24px;
		font-weight: bold;
	}

	.visa-hot_nav img {
		width: 70px;
		height: 49px;
		margin-bottom: 8px;
	}

	.visa-hot_nav label {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		margin-bottom: 40px;
		width: 25%;
	}

	.visaList {
		width: 100%;
		padding: 20px;
		box-sizing: border-box;
	}

	.visaList-item {
		width: 100%;
		border-bottom: 1px solid #e5e5e5;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 20px 0;
	}

	.visaList-item_left {
		width: 33%;
		position: relative;
	}

	.visaList-item_left img {
		height: 170px;
		width: 100%;
		border-radius: 15px;
	}

	.visaList-item_left label {
		border-radius: 15px;
		height: 170px;
		width: 100%;
		position: absolute;
		top: 0;
		left: 0;
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
	}


	.visaList-item_left label p {
		height: 44px;
		line-height: 44px;
		width: 100%;
		text-align: center;
		background-color: rgba(0, 0, 0, .7);
		color: #ffb42e;
		font-size: 24px;
		border-bottom-right-radius: 15px;
		border-bottom-left-radius: 15px;
	}

	.visaList-item_right {
		width: 65%;
		float: right;
		overflow: hidden;
		height: 170px;
		display: flex;
		flex-direction: column;
	}

	.visaList-item_right h2 {
		font-size: 27px;
		width: 100%;
		color: #333;
		font-weight: bold;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
		overflow: hidden;
	}

	.visaList-item_right p {
		font-size: 24px;
		margin-top: 10px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}

	.visaList-item_right label {
		font-size: 30px;
		color: #ff6d00;
		float: right;
		font-weight: bold;
		margin-top: auto;
		margin-left: auto;
		display: flex;
		align-items: center
	}

	.visaList-item_right font {
		color: #666;
		font-size: 24px;
		padding-left: 7px;
	}

	.image-ad {
		width: 100%;
		height: 378px;
	}
</style>